import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/distinctUntilChanged';

import { AppState } from '../../app.state';

@Injectable()
export class NgReduxStub {

  constructor(private store: Store<AppState>) {}

  public dispatch(action: any): void {
    this.store.dispatch(action);
  }

  public connect(mapStateToTarget, mapDispatchToTarget): Function {
    let slice = this.getStateSlice(this.getState(), mapStateToTarget);

    return (target) => {
      // Initial target update
      this.updateTarget(target, slice);

      if (mapDispatchToTarget) {
        this.boundActionCreators(target, mapDispatchToTarget);
      }

      const subscription = this.store.subscribe((state) => {
        const nextSlice = this.getStateSlice(state, mapStateToTarget);

        if (!this.shallowEqual(slice, nextSlice)) {
          slice = nextSlice;
          this.updateTarget(target, slice);
        }
      });

      return subscription.unsubscribe.bind(subscription);
    };
  }

  public getState(): any {
    let state: AppState;

    this.store.take(1).subscribe(s => state = s).unsubscribe();

    return state;
  }

  public subscribe(callback: any): Function {
    const subscription = this.store.subscribe(callback);
    return subscription.unsubscribe.bind(subscription);
  }

  private boundActionCreators(target, mapDispatchToTarget) {
    const store = this.store;

    for (let key of Object.keys(mapDispatchToTarget)) {
      if (typeof mapDispatchToTarget[key] === 'function') {
        const action = mapDispatchToTarget[key];

        target[key] = function() {
          store.dispatch(action.apply(null, arguments));
        };
      }
    }
  }

  private updateTarget(target, slice) {
    Object.assign(target, slice);
  }

  private getStateSlice(state, mapStateToScope) {
    return mapStateToScope(state);
  }

  // Copied from $ngRedux lib (ng-redux/lib/utils/shallowEqual.js)
  private shallowEqual(objA, objB) {
    if (objA === objB) {
      return true;
    }

    /* $$hashKey is added by angular when using ng-repeat, we ignore that*/
    const keysA = Object.keys(objA).filter(k => (k !== '$$hashKey'));
    const keysB = Object.keys(objB).filter(k => (k !== '$$hashKey'));

    if (keysA.length !== keysB.length) {
      return false;
    }

    // Test for A's keys different from B.
    const hasOwn = Object.prototype.hasOwnProperty;
    for (let i = 0; i < keysA.length; i++) {
      if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
        return false;
      }
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/services/ng-redux-stub.service.ts